import { apiRequest } from "../services/apiService";

/*
|--------------------------------------------------------------------------
| Login
|--------------------------------------------------------------------------
*/

export async function login(user, password) {
  return await apiRequest("login", "POST", {
    user,
    password,
  });
}

/*
|--------------------------------------------------------------------------
| Login errors
|--------------------------------------------------------------------------
*/

export function getLoginError(responseCode) {
  const errors = {
    403: {
      title: "Błąd",
      severity: "error",
      info: "Brak uprawnień lub niewłaściwe hasło!",
    },

    501: {
      title: "Błąd",
      severity: "error",
      info: "Konto nieaktywne, zablokowane lub nie istnieje!",
    },

    502: {
      title: "Ostrzeżenie",
      severity: "warning",
      info: "Nie podano nazwy użytkownika.",
    },

    503: {
      title: "Ostrzeżenie",
      severity: "warning",
      info: "Nie podano hasła.",
    },
  };

  return errors[responseCode] ?? null;
}
